import styled from 'styled-components'
import Text from '../../../../../components/text'

export const StyledAdminPart = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 70%;
  min-height: 100vh;
  gap: 2rem;
  padding: 1rem;
  box-sizing: border-box;
  background-color: #f3f4f8;
  @media (max-width: ${(props) => props.theme.responsive.laptop}) {
    width: 100vw;
  }
`

export const AddSection = styled.div<{ showAdd: boolean }>`
  display: ${(props) => (props.showAdd ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  padding: 1rem 0;
  gap: 4rem;
  background-color: #f3f4f8;
  width: 100vw;
  position: absolute;
  top: 0;
  z-index: 1000;
  background-color: ${(props) => props.theme.colors.grey};
`

export const StyledPreview = styled.div<{ mobilePreview: boolean }>`
  direction: rtl;
  width: ${(props) => (props.mobilePreview ? '320px' : '100%')};
  height: ${(props) => (props.mobilePreview ? '650px' : '100%')};
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
`
export const CardPart = styled.img`
  width: 10rem;
  padding: 2.25rem 1.75rem;
  background: white;
  border-radius: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  cursor: pointer;
  transition: all 0.6s;

  &:hover {
    transform: translateY(-8px);
  }
`

export const StyledIcons = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  cursor: pointer;
`

export const CardsPart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
`
